import { useEffect, useState, useCallback } from "react";

// Persists light/dark mode in localStorage with system-preference fallback.
// Toggles the `.dark` class on <html> so Tailwind + CSS-variable swaps apply.
export function useTheme() {
    const [theme, setTheme] = useState(() => {
        if (typeof window === "undefined") return "light";
        const saved = window.localStorage.getItem("mochi-theme");
        if (saved === "light" || saved === "dark") return saved;
        return window.matchMedia?.("(prefers-color-scheme: dark)").matches ? "dark" : "light";
    });

    useEffect(() => {
        const root = document.documentElement;
        if (theme === "dark") root.classList.add("dark");
        else root.classList.remove("dark");
        // localStorage can throw in Safari private mode — silent ok, the
        // theme just won't persist across page loads for that one session.
        try { window.localStorage.setItem("mochi-theme", theme); } catch { /* storage unavailable */ }
    }, [theme]);

    const toggleTheme = useCallback(() => {
        setTheme((t) => (t === "dark" ? "light" : "dark"));
    }, []);

    return { theme, toggleTheme };
}
